import MyStaffApplications from "./Template";

const MyOtApplications = () => <MyStaffApplications type="OT" />;

export default MyOtApplications;
